import Calendar, { CalendarProps } from "./Calendar";
import { withLabel } from "composants/withLabel";

export default withLabel<CalendarProps>()(Calendar);
